import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col, Typography, Spin, Input, InputNumber, Button, Tabs, notification, Switch } from 'antd';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../i18n/adminI18n';
import './BookingCategoryModal.css';

const { Text } = Typography;
const { TabPane } = Tabs;

@inject(
    'CmsLanguageStore',
    'BookingCategoryStore',
)
@observer
class BookingCategoryModalPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false
        }
    }

    componentDidMount() {
        this.props.CmsLanguageStore.getActives();
    }

    // ON CHANGE

    nameOnChange = (langId, e) => {
        this.props.BookingCategoryStore.setBookingCategoryLanguageName(langId, e.target.value);
    }

    descriptionOnChange = (langId, e) => {
        this.props.BookingCategoryStore.setBookingCategoryLanguageDescription(langId, e.target.value);
    }

    capacityOnChange = (value) => {
        this.props.BookingCategoryStore.setCapacity(value);
    }

    isAvailableOnChange = (value) => {
        this.props.BookingCategoryStore.setIsAvailable(value);
    }

    maxHourPerDayOnChange = (value) => {
        this.props.BookingCategoryStore.setMaxHourPerDay(value);
    }

    sortOrderOnChange = (value) => {
        this.props.BookingCategoryStore.setSortOrder(value);
    }

    // ON CLICK

    createOrUpdateBookingCategoryDetailOnClick = () => {
        this.props.BookingCategoryStore.createOrUpdateBookingCategoryDetail();
    }

    initUpdateBookingCategoryDetailOnClick = (bookingCategoryDetailId) => {
        this.props.BookingCategoryStore.initUpdateBookingCategoryDetail(bookingCategoryDetailId);
    }

    cancelBookingCategoryDetailOnClick = () => {
        this.props.BookingCategoryStore.cancelBookingCategoryDetail();
    }

    deleteBookingCategoryDetailOnClick = (bookingCategoryDetailId) => {
        this.props.BookingCategoryStore.deleteBookingCategoryDetail(bookingCategoryDetailId);
    }

    createOrUpdateBookingCategoryOnClick = () => {
        const { t } = this.props;
        const { id } = this.props.BookingCategoryStore;
        if (id === 0) {
            this.props.BookingCategoryStore.createBookingCategory().then(response => {
                if (response.isSuccess) {
                    notification['success']({
                        message: t('Success'),
                        description: t('Booking Category has been successfully created.'),
                        duration: 3
                    });
                } else {
                    notification['error']({
                        message: t('Error'),
                        description: `${response.error}`,
                        duration: 3
                    });
                }
            });
        } else {
            this.props.BookingCategoryStore.updateBookingCategory().then(response => {
                if (response.isSuccess) {
                    notification['success']({
                        message: t('Success'),
                        description: t('Booking Category has been successfully updated.'),
                        duration: 3
                    });
                } else {
                    notification['error']({
                        message: t('Error'),
                        description: `${response.error}`,
                        duration: 3
                    });
                }
            });
        }
    }

    // ON TAB CLICK

    tabNameOnTabClick = (key) => {
        this.props.BookingCategoryStore.setTabNameActiveKey(key);
    }

    tabDescriptionOnTabClick = (key) => {
        this.props.BookingCategoryStore.setTabDescriptionActiveKey(key);
    }



    render() {
        const { t } = this.props;
        const { activeLanguages } = this.props.CmsLanguageStore;

        const {
            tabNameActiveKey,
            tabDescriptionActiveKey,
            bookingCategoryLanguages,
            capacity,
            isAvailable,
            maxHourPerDay,
            sortOrder,
            itemTextButton,
            bookingCategoryModalLoading
        } = this.props.BookingCategoryStore;

        let addOrUpdateItemDisable = false;
        const primaryLang = bookingCategoryLanguages.find(lang => lang.langId === 1);
        if (!primaryLang || primaryLang.name === '') {
            addOrUpdateItemDisable = true;
        }

        return (
            <>
                {
                    activeLanguages
                        ?
                        <>
                            <Spin spinning={bookingCategoryModalLoading}>
                                <Row className='bookingcategorymodal-row-container'>
                                    <Col span={24} className='bookingcategorymodal-col'>
                                        <Row>
                                            <Col span={8} className='bookingcategorymodal-col-label-tabs'>
                                                <Text className='bookingcategorymodal-text-label'>{t('Name')}<Text className='bookingcategorymodal-text-label-mandatory'>*</Text></Text>
                                            </Col>
                                            <Col span={16} className='bookingcategorymodal-col-input'>
                                                <Tabs activeKey={tabNameActiveKey} onTabClick={this.tabNameOnTabClick}>
                                                    {
                                                        activeLanguages && activeLanguages.map(lang => {
                                                            const langData = bookingCategoryLanguages.find(bcl => bcl.langId === lang.id);
                                                            const isPrimary = lang.id === 1; // English is primary
                                                            return (
                                                                <TabPane
                                                                    tab={`${lang.originalName}${isPrimary ? ' *' : ''}`}
                                                                    key={lang.id.toString()}
                                                                >
                                                                    <Input
                                                                        className='bookingcategorymodal-input'
                                                                        value={langData ? langData.name : ''}
                                                                        onChange={(e) => this.nameOnChange(lang.id, e)}
                                                                    />
                                                                </TabPane>
                                                            );
                                                        })
                                                    }
                                                </Tabs>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='bookingcategorymodal-col'>
                                        <Row>
                                            <Col span={8} className='bookingcategorymodal-col-label-tabs'>
                                                <Text className='bookingcategorymodal-text-label'>{t('Description')}<Text className='bookingcategorymodal-text-label-mandatory'>*</Text></Text>
                                            </Col>
                                            <Col span={16} className='bookingcategorymodal-col-input'>
                                                <Tabs activeKey={tabDescriptionActiveKey} onTabClick={this.tabDescriptionOnTabClick}>
                                                    {
                                                        activeLanguages && activeLanguages.map(lang => {
                                                            const langData = bookingCategoryLanguages.find(bcl => bcl.langId === lang.id);
                                                            const isPrimary = lang.id === 1; // English is primary
                                                            return (
                                                                <TabPane
                                                                    tab={`${lang.originalName}${isPrimary ? ' *' : ''}`}
                                                                    key={lang.id.toString()}
                                                                >
                                                                    <Input
                                                                        className='bookingcategorymodal-input'
                                                                        value={langData ? langData.description : ''}
                                                                        onChange={(e) => this.descriptionOnChange(lang.id, e)}
                                                                    />
                                                                </TabPane>
                                                            );
                                                        })
                                                    }
                                                </Tabs>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='bookingcategorymodal-col'>
                                        <Row>
                                            <Col span={8} className='bookingcategorymodal-col-label'>
                                                <Text className='bookingcategorymodal-text-label'>{t('Capacity')}<Text className='bookingcategorymodal-text-label-mandatory'>*</Text></Text>
                                            </Col>
                                            <Col span={16} className='bookingcategorymodal-col-input'>
                                                <InputNumber
                                                    className='fnbadditionalitemmodal-inputnumber-short'
                                                    min={1}
                                                    value={capacity}
                                                    onChange={this.capacityOnChange}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='bookingcategorymodal-col'>
                                        <Row>
                                            <Col span={8} className='bookingcategorymodal-col-label'>
                                                <Text className='bookingcategorymodal-text-label'>{t('Max Hour Per Day')}<Text className='bookingcategorymodal-text-label-mandatory'>*</Text></Text>
                                            </Col>
                                            <Col span={16} className='bookingcategorymodal-col-input'>
                                                <InputNumber
                                                    className='fnbadditionalitemmodal-inputnumber-short'
                                                    min={0}
                                                    value={maxHourPerDay}
                                                    onChange={this.maxHourPerDayOnChange}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='bookingcategorymodal-col'>
                                        <Row>
                                            <Col span={8} className='bookingcategorymodal-col-label'>
                                                <Text className='bookingcategorymodal-text-label'>{t('Sort Order')}<Text className='bookingcategorymodal-text-label-mandatory'>*</Text></Text>
                                            </Col>
                                            <Col span={16} className='bookingcategorymodal-col-input'>
                                                <InputNumber
                                                    className='fnbadditionalitemmodal-inputnumber-short'
                                                    min={0}
                                                    value={sortOrder}
                                                    onChange={this.sortOrderOnChange}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='bookingcategorymodal-col'>
                                        <Row>
                                            <Col span={8} className='bookingcategorymodal-col-label'>
                                                <Text className='bookingcategorymodal-text-label'>{t('Is Available')}</Text>
                                            </Col>
                                            <Col span={16} className='bookingcategorymodal-col-input'>
                                                <Switch checkedChildren={t('Yes')} unCheckedChildren={t('No')} checked={isAvailable} onChange={this.isAvailableOnChange} />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='bookingcategorymodal-col-button'>
                                        <Button disabled={addOrUpdateItemDisable} type='primary' className='bookingcategorymodal-button' onClick={this.createOrUpdateBookingCategoryOnClick}>{t(itemTextButton)}</Button>
                                    </Col>
                                </Row>
                            </Spin >
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(BookingCategoryModalPage);
